import React from "react";
import { SpendableDetails } from "../interfaces/SpendableDetails";
import { SpendablesContext } from "../contexts/SpendablesContext";
import SpendImprovementView from "./SpendImprovementView";
import { SpendingOnType } from "../interfaces/SpendablesForModules";

interface Props {
  moduleKey: string;
  spendingOn: SpendingOnType;
}

export default ({ moduleKey, spendingOn }: Props) => {
  const { moduleSpendables } = React.useContext(SpendablesContext);
  return (
    <>
      {moduleSpendables[moduleKey]?.map(
        (spendableDetails: SpendableDetails, i) => (
          <SpendImprovementView
            key={`${moduleKey}-${i}`}
            moduleKey={moduleKey}
            spendableDetails={spendableDetails}
            spendingOn={spendingOn}
            i={i}
          />
        )
      )}
    </>
  );
};
